export const SLIDER_PAGE_STEP_MULTIPLIER = 10;
export function createNumericRange(min, max, step) {
  const resolvedMin = Number.isFinite(min) ? min : 0;
  const resolvedMax = Number.isFinite(max) ? max : 100;
  const lowerBound = Math.min(resolvedMin, resolvedMax);
  const upperBound = Math.max(resolvedMin, resolvedMax);
  const resolvedStep = Number.isFinite(step) && step > 0 ? step : 1;
  const span = upperBound - lowerBound;
  const clamp = value => {
    const candidate = Number.isFinite(value) ? value : lowerBound;
    const stepped = lowerBound + Math.round((candidate - lowerBound) / resolvedStep) * resolvedStep;
    return Math.min(upperBound, Math.max(lowerBound, stepped));
  };
  return {
    lowerBound,
    upperBound,
    step: resolvedStep,
    clamp,
    ratioFor: value => span === 0 ? 0 : (clamp(value) - lowerBound) / span,
    valueFromRatio: ratio => {
      const unit = Math.min(1, Math.max(0, Number.isFinite(ratio) ? ratio : 0));
      return clamp(lowerBound + unit * span);
    }
  };
}
export function valueFromSliderKey(range, current, key) {
  switch (key) {
    case "ArrowRight":
    case "ArrowUp":
      return range.clamp(current + range.step);
    case "ArrowLeft":
    case "ArrowDown":
      return range.clamp(current - range.step);
    case "Home":
      return range.lowerBound;
    case "End":
      return range.upperBound;
    case "PageUp":
      return range.clamp(current + range.step * SLIDER_PAGE_STEP_MULTIPLIER);
    case "PageDown":
      return range.clamp(current - range.step * SLIDER_PAGE_STEP_MULTIPLIER);
    default:
      return void 0;
  }
}